export const FILE_URL = '/api/fileupload';
